// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__3YHwN","clickedWithMouse":"MenuLabel_clickedWithMouse__48Ncy","isOpen":"MenuLabel_isOpen__3ifli"};